import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';

import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
} from '@angular/material/dialog';

import {ImageAsset} from '@app/asset';
import {Rect} from '@app/shared/euclid';
import Cropper from 'cropperjs';

@Component({
    selector: 'frog-cropper-dialog',
    templateUrl: './cropper-dialog.component.html',
    styleUrls: ['./cropper-dialog.component.scss'],
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
})
export class CropperDialogComponent implements OnInit, AfterViewInit {
    @ViewChild('image') image;

    private cropper: Cropper;

    constructor(
        public dialogRef: MatDialogRef<CropperDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ImageAsset,
    ) {}

    ngOnInit(): void {}

    ngAfterViewInit() {
        this.cropper = new Cropper(this.image.nativeElement, {
            aspectRatio: 1.0,
            scalable: false,
            zoomable: true,
            rotatable: false,
        });
    }

    save() {
        const cropData = Object.assign(new Rect(), this.cropper.getData(true));
        this.dialogRef.close(cropData);
    }
}
